<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">qr_code_2</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Séries vinculadas</h2>
    <span class="modal-subtitle">{{ data.descricaoOperacao }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (data.series.length === 0) {
  <p class="empty-text">Nenhuma série vinculada a esta movimentação.</p>
  } @else {
  <div class="series-list">
    @for (s of data.series; track s.idSerie) {
    <div class="series-item">{{ s.codigoSerie }}</div>
    }
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
